export default __webpack_public_path__ + "static/media/aceN Logo.d6984d30.png";